import enLocale from "element-ui/lib/locale/lang/en";
const en = {
  login: {
    buttoo: {
      add: "add",
    },
  },
  dialog: {
    buttton: {
      close: "Close",
    },
    ReportError: {
      next: "Next",
      h1: "Report Errors allows users to communicate with us to solve any data issues and improve data quality.",
      li1: "If you find any data problems or have a question about this data",
      li2: "If you want to contribute company information to improve this data",
      li3: "If you choose not to disclose your own company information that you might consider private",
      li4: "If you have any constructive suggestions for us to improve services",
      h2: "All comments submitted are subject to data verification. Users must complete your own user profile as our representative may contact you for authentication and verification of your company any rights to represent your company.",
    },
  },
  Home: {
    Applications: "Applications",
    SearchCompanies: "Search Companies",
    SearchTrade: "Search Trade",
    SearchRisks: "Search Risks",
    SearchCountries: "Search Countries",
    SearchNews: "Search News",
    SearchLeads: "Search Leads",
    SearchSanctions: "Search Sanctions",
    RiskScan: "Risk Scan",
    SearchRelationship: "Search Relationship",
    DataServices: "Data Services",
    selectCountry: "Select Country", //选择公司
    inputCompany: "Enter company name", //输入公司名称
    keWord: "Keyword", //关键词
    firstWord: "Exact Left", //首词
    search: "Search", //搜索
    homeSeachTitle: "Bringing Global Business Into Focus", //聚焦全球商情
    homeTitleDetail:
      "CSI, a data-driven research and IT firm, specializes in credit, risk, and big data. It offers digital tools to global investors and business professionals, leveraging advanced analytics and algorithms to provide fast, visual insights that facilitate smarter decision-making. ",
    phoneTitleDetail:
      "To quickly search, view, and obtain company information, you can also use the CSI App on your phone. ", //您可以使用手机上的 CSI App 快速搜索、查看和获取公司信息。,
    searchCompanyNum:
      "Search 500+ million companies in 200+ countries and territories",
    IndustryAnalysis: "Industry Analysis",
    BusinessAnalytics: "Business Analytics",
    ImportExportData: "Import-Export Data",
    CompanyNews: "Company News",
    Sanctions: "Sanctions",
    BusinessIntelligence: "Business Intelligence",
    CompanyIdentityVerification: "Company Identity Verification",
    KYCSolutions: "KYC Solutions",
    OwnershipPenetration: "Ownership Penetration",
    CompanyFinancialAnalysis: "Company Financial Analysis",
    CreditRatings: "Credit Ratings",
    CreditReports: "Credit Reports",
    ESGRatings: "ESG Ratings",
    VendorScreening: "Vendor Screening ",
    MarketResearch: "Market Research ",
    EnterKeyword: "Enter Keyword",
  },
  Toolbar: {
    Filter: "Filter",
    Select: "Select",
    Edit: "Edit",
    Sortby: "Sort by",
    Collect: "Collect",
    Saved: "Saved",
    Compare: "Compare",
    Export: "Export",
    Download: "Download",
    Update: "Update",
    Reporterror: "Report error",
    Share: "Share",
    ascending: "Ascending",
    descending: "Descending",
    Customfolder: "Custom folder",
    RiskScanning: "Risk Scanning",
    CreditAssessment: "Credit Assessment",
    DataAnalysis: "Data Analysis",
    NewPortfolio: "New Portfolio",
    Print: "Print",
  },
  AiZaba: {
    whatareyousearchingfor: "What are you searching for?",
    CreditAnalyst: "Credit Analyst",
    Assesses:
      "Assesses a company'screditworthiness,identifiesfinancial risks,ensuring secure transactionsthrough data analysis andcredit ratings.",
    LegalAdvisor: "Legal Advisor",
    Provides:
      "Provides compliance guidance,reviews contracts,andassesseslegarisks to ensure businessoperations align with lawsand avoid disputes.",
    BizConsultant: "Biz Consultant",
    Optimizes:
      "Optimizes supply chains,identifiesbuyers, andboosts sales by analyzingmarket trends and offeringtailored strategies to improve efficiency",
    EconomicAnalyst: "Economic Analyst",
    Analyzes:
      "Analyzes industry and regional economic trendshelping businesses makeinformed decisions, and staycompetitive.",
  },
  navigationBar: {
    Notifications: "Notifications", //通知
    MarkasRead: "Mark as Read", //标记已读
    Viewall: "View all", //查看全部
    SilverSubscriber: "Silver Subscriber", //银级用户
    Silversubscriberdate: "Silver subscription expiration date", //银级到期日
    GoldSubscriber: "Gold Subscriber", //金级用户
    Goldsubscriptiondate: "Gold subscription expiration date", //金级到期日
    AvailableCredits: "Available Credits", //可用积分
    AddCredits: "Add Credits", //购买积分
    IndivdualAccount: "Indivdual Account", //个人账号
    GroupAccount: "Group Account", //集团账号
    OrdinaryUsers: "Ordinary users",
    UserAccount: "User Account",
    Roles: "Roles", //角色
  },
  ListofResults: {
    Country: "Country",
    Industry: "Industry",
    CompanyType: "Company Type",
    CompanySize: "Company Size",
    CompanyStatus: "Company Status",
    CompanyName: "Company Name",
    CoType: "Co. Type",
    RegStatus: "Reg. Status",
    StateProvince: "State/Province",
    CityCounty: "City/County",
    DistrictCity: "District/City",
    IncDate: "Inc. Date",
    LegalForm: "Legal Form",
    CoID: "Co. ID",
    TaxNo: "Tax No",
    ListingInfo: "Listing Info",
    Phone: "Phone",
    Website: "Website",
    Email: "Email",
    LegalPerson: "Legal Person",
    PostCode: "Post Code",
    ISIC: "ISIC",
    IndustryDescription: "Industry Description",
    NACE: "NACE",
    NAICS: "NAICS",
    CreditRating: "Credit Rating",
    SolvencyIndex: "Solvency Index",
    ProbabilityofDefault: "Probability of Default",
    NoofEmployees: "No. of Employees",
    Revenue: "Revenue",
    TotalAsset: "Total Asset",
    NetProfit: "Net Profit",
    ROA: "ROA",
    ROE: "ROE",
    ShowMore: "Show More",
    SelectCountry: "Select Country",
    ClearAll: "Clear All",
    SelectIndustry: "Select Industry",
    ListedCompany: "Listed Company",
    YearsinBusiness: "Years in Business",
    Sharethisinformation: "Share this information",
    Pleaseaddress: "Please enter one or more email address :",
    Example: "Example",
    message: "Message",
    pleaseleaveamessage: "Please leave a message",
    Include: "Include",
    thisaddress: "This company name , ID , address",
    CSIwebsite: "CSI website",
    Update: "Update",
    Iftheavailable:
      "If the available online data is insufficient or outdated, you can click the “Update” button to request an instant update for a fresh investigated business credit report from our local networking investigators or credit reporting agencies. The cost for this update is 1 credit per company. The update report typically takes between 24 and 72 hours to be delivered.",
    Abusinesscredit:
      "A business credit report provides detailed information about the subject company’s identification data, registry records, shareholding structure, company history, management description, related companies, actual operations, trade references, financial data and analysis, official public information such as litigation records and sanctions, and credit analysis and assessment.",
    Searchcompanies: "Search more emails on other companies",
    Rowsperpage: "Rows per page",
    Foundover: "Found over",
    results: "results",
    Remove: "Remove",
    Confirm: "Confirm",
    Rescan: "Rescan",
  },
  ContentTabs: {
    Background: "Background",
    BusinessActivities: "Business Activities",
    Performance: "Performance",
    Publications: "Publications",
    CreditOpinion: "Credit Opinion",
    MarketAnalysis: "Market Analysis",
    Snapshot: "Snapshot",
    Profile: "Profile",
    Ownership: "Ownership",
    RelatedCompanies: "Related Companies",
    Management: "Management",
    Operations: "Operations",
    Locations: "Locations",
    Industry: "Industry",
    ImportExport: "Import & Export",
    SupplyChain: "Supply Chain",
    FinancialHighlights: "Financial Highlights",
    RatioAnalysis: "Ratio Analysis",
    IndustryNorm: "Industry Norm",
    News: "News",
    Sanctions: "Sanctions",
    IndustryStatistics: "Industry Statistics",
    RatingAnalysis: "Rating Analysis",
    CompetitiveAnalysis: "Competitive Analysis",
    Lawsuits: "Lawsuits",
  },
  Snapshot: {
    CompanyDQIdesc1:
      "The Data Quality Index (DQI) employs algorithms to assess different aspects of data, including completeness, validity, reliability of sources, consistency, timeliness, and bilingual support.",
    CompanyDQIdesc2:
      "The index is designed to assess the quality of data on a scale of 1 to 100, with higher scores indicating superior data quality. Algorithms can analyze data based on predefined rules or criteria, enabling objective and standardized measurements.",
    CompanyDQIdesc3:
      "Our Data Quality Index (DQI) serves as a reliable indicator, allowing users to quantitatively assess data quality. This enables data-driven decision-making and enhances the overall value and utility of the data.",
    CountryDQIdesc1:
      "The Data Quality Index (DQI) assesses the reliability, accuracy, and accessibility of data across countries, reflecting differences in digital infrastructure, governance, and transparency. Developed nations typically rank higher due to strong data systems, open policies, and advanced technology, while developing economies often struggle with gaps in infrastructure, regulation, or data-sharing practices.",
    CountryDQIdesc2:
      "Key factors include government transparency, data protection laws, and technological adoption. A high DQI enables better policymaking and business decisions, while a low score highlights areas needing investment.",
    CompanyDQI: "Company DQI", //公司数据质量指数 DQI
    CountryDQI: "Country DQI", //国家数据质量指数 DQI
    CompanyTitle: "Data Quality Index (DQI) by Company",
    CountryTitle: "Data Quality Index (DQI) by Country",
    Address: "Address", //地址
    CountyCity: "County/City", //县/市
    ProvinceState: "Province/State", //省/州
    CountryRegion: "Country/Region", //国家/地区
    ZipCode: "Zip Code", //邮政编码
    Website: "Website", //网站
    Email: "Email", //电邮
    Tel: "Tel", //电话
    LastUpdate: "Last Update", //最近更新
    DataSource: "Data Source", //数据来源
    LegalStatus: "Legal Status", //法定状况
    CoID: "Co. ID", //公司ID
    CompanyType: "Company Type", //公司类型
    RegistrationDate: "Registration Date", //注册日期
    RegistrationStatus: "Registration Status", //注册状态
    Listed: "Listed", //上市信息
    CurrentOpperations: "Current Operations", //经营状况
    IndustryCode: "Industry Code", //行业代码
    BusinessActivities: "Business Activities", //主营业务
    NoofEmployees: "No. of Employees", //员工数量
    NoofShareholders: "No. of Shareholders", //股东数量
    Management: "Management", //管理状况
    Performance: "Performance", //业绩表现
    Revenue: "Revenue", //收入
    Assets: "Assets", //资产
    ProfitLoss: "Profit/Loss", //利润
    Growth: "Growth", //公司增长
    Competitiveness: "Competitiveness", //竞争力
    CreditOpinion: "Credit Opinion", //信用状况
    CreditRating: "Credit Rating", //信用评级
    CreditScore: "Credit Score", //信用评分
    ESGRating: "ESG Rating", //ESG 评级
    Solvency: "Solvency", //偿还能力
    Sanctions: "Sanctions", //全球制裁
    CoName: "Co. Name",
    RegName: "Reg. Name",
  },
  Profile: {
    CompareCompanies: "Compare Companies",
    AddaCompany: "Add a Company",
    CompanyProfile: "Company Profile", //基本资料
    CompanyName: "Company Name", //公司名称
    NativeName: "Native Name", //当地名称
    CompanyID: "Company ID", //公司 ID
    VATNumber: "VAT Number", //VAT号
    StockCode: "Stock Code", //股票代码
    Listed: "Listed", //上市日期
    RegistrationDate: "Registration Date", //注册日期
    LegalForm: "Legal Form", //公司性质
    CompanyType: "Company Type", //公司类型
    LegalStatus: "Legal Status", //注册状态
    Jurisdiction: "Jurisdiction", //司法管辖区
    RegisteredAddress: "Registered Address", //注册地址
    ProvinceState: "Province/State", //省/州
    CountryRegion: "Country/Region", //国家/地区
    ZipCode: "Zip Code", //邮政编码
    OperatingAddress: "Operating Address", //经营地址
    LastUpdate: "Last Update", //最近更新
    DataSource: "Data Source", //数据来源
    History: "History", //历史记录
    RegisteredCapital: "Registered Capital",
    PaidinCapital: "Paid-in Capital",
    CountyCity: "County/City",
  },
  Ownership: {
    UltimateBeneficiary: "Ultimate Beneficiary Owner", //最终受益人
    InvolvingIndividuals: "Involving Individuals", //涉及自然人股东
    InvolvingEnterprises: "Involving Enterprises", //涉及法人股东
    ShareholderLevel: "Shareholder Level", //股东层级x
    Name: "Name", //名称
    Country: "Country", //国家/地区
    Location: "Location", //地点
    Type: "Type", //类型
    Shares: "Shares", //股份
    Relation: "Relation", //关系
    Individuals: "Individuals", //关系
    PartiesInvolved: "Parties Involved",
    RelatedCompany: "Related Company",
    CompanyShareholders: "Company Shareholders",
    NGOShareholders: "NGO Shareholders",
    NaturalPersonShareholder: "Natural Person Shareholder",
    SubjectInvestments: "Subject's Investments",
  },
  RelatedCompanies: {
    Total: "Total", //相关公司总计
    Entities: "Entities", //法人实体
    Countries: "Countries", //国家/地区
    Branches: "Branches", //分支机构
    RelatedComp: "Related Companies", //关联公司
    Name: "Name", //名称
    Country: "Country", //国家/地区
    Location: "Location", //地点
    Type: "Type", //类型
    Relation: "Relationship", //关系
    BranchOffices: "Branch Offices",
    Individuals: "Individuals",
  },
  Management: {
    Management: "Management", //管理层
    ContactInfo: "Contact Info", //联系人信息
    Countries: "Countries", //国家/地区
    Name: "Name", //名称
    Position: "Position", //职位
    Department: "Department", //部门
    Country: "Country", //国家/地区
    ShareholderNot: "Shareholder or Not", //是否股东
    Relation: "Relations", //关系
    Verification: "Verification", //已验证
    Searchmoreemails: "Search more emails", //搜索更多电邮
    Roles: "Roles", //角色
    EducationLevel: "Education Level", //教育程度
    Phone: "Phone", //电话
    Email: "Email", //电邮
    Verified: "Verified", //已验证
    Searchmore: "Search more emails on other companies", //搜索更多其他公司的电邮
    Pleaseentername: "Please enter name",
    PleaseenterWebsite: "Please enter Website",
    UserSelfVerification: "User Self Verification",
    Userverified: "User verified",
  },
  Operations: {
    Operations: "Operations",
    LineofBusiness: "Line of Business", //业务范围
    BusinessTerritories: "Business Territories", //业务区域
    ImportExport: "Import & Export", //进出口信息
    Viewtradeinfo: "View more trade info", //查看更多贸易信息
    ProductsServices: "Products/Services", //产品/服务
    Products: "Products", //产品
    ProductImage: "Product Image", //产品图片
    ProductName: "Product Name", //产品名称
    ProductDescription: "Product Description", //产品描述
    Details: "Details", //详情
    Addproductinformation: "Add product information ", //添加产品信息
    Showcaseyourcompany:
      "If you’d like to showcase your company’s products or services to the public, you can add your product and service information here. This is a great way to promote your business. Once we’ve reviewed your submission, your data will be published.",
  },
  Locations: {
    Locations: "Locations",
    CoName: "Co. Name", //业务范围
    Relationship: "Relationship", //关系
    Type: "Type", //类型
    Country: "Country", //国家/地区
    Location: "Location", //地点
    Address: "Address", //地址
    Edit: "Edit", //编辑
    CompanyLocatiionsMap: "Company Locations in Map", //地图中的公司位置
    Selectaddresstype: "Select address type", //选择地址类型
    Subjectcompany: "Subject company", //目标公司
    Subsidiary: "Subsidiary", //子公司
    RegisteredAddress: "Registered Address", //注册地址
    OperationAddress: "Operation Address", //运营地址
    All: "All", //全部
    Showlocation: "Show location ",
  },
  Industry: {
    IndustryTitle: "Industry Title", //IndustryTitle
    IndustryDescription: "Industry Description", //IndustryDescription
    ISIC: "ISIC", //ISIC
    ISICDescription: "ISIC Description", //ISICDescription
    NACE: "NACE", //NACEDescription
    NACEDescription: "NACE Description", //NACEDescription
    NAICS: "NAICS", //NAICS
    NAICSDescription: "NAICS Description", //NAICSDescription
    CSIC: "CSIC", //CSIC,
    CSICDescription: "CSIC Description", //CSICDescription
    AAAIC: "AAAIC", //AAAIC
    AAAICDescription: "AAAIC Description", //AAAICDescription
    GICS: "GICS", //GICS
    GICSDescriptio: "GICS Descriptio", //GICS 描述
  },
  ImportExport: {
    TotalImportAmount: "Total Import Amount", //进口总额
    TopImportCountry: "Top Import Country", //最大进口国家/地区
    TopImportProduct: "Top Import Product", //最大进口产品
    TotalExport: "Total Export Amount", //出口总额
    TopExportCountry: "Top Export Country", //最大出口国家/地区
    TopExportProduct: "Top Export Product", //最大出口产品
    TradeVolume: "Trade Volume", //贸易额
    ImportShipments: "Import Shipments", //进口量
    ExportShipments: "Export Shipments", //出口量
    ImportCountries: "Import Countries", //进口国家/地区
    ExportCountries: "Export Countries", //出口国家/地区
    ImportVolume: "Import Volume ", //进口量
    ExportVolume: "Export Volume", //出口量
    TopSuppliers: "Top Suppliers", //主要供应商
    ByNumberofShipments: "By Number of Shipments", //按出货量
    TopBuyers: "Top Buyers", //主要买家
    ByNumberofShipments: "By Number of Shipments", //按出货量
    ImportQuantity: "Import Quantity", //进口数量
    IncreaseDecreasexRate: "Increase/Decrease Rate", //增/减率
    ExportQuantity: "Export Quantity", //出口数量
    ImportsExportsRecords: "Imports & Exports Records", //进出口记录
    Date: "Date", //日期
    Product: "Product", //产品
    HSCode: "HS Code", //HS 编码
    BuyerName: "Buyer Name", //买家名称
    Destination: "Destination", //目的地
    SupplierName: "Supplier Name", //供应商名称
    Origin: "Origin", //原产地
    Amount: "Amount", //金额
    Details: "Details", //详情
    Imports: "Imports",
    Exports: "Exports",
    Shipments: "Shipments",
    value: "value",
    ByNumberofvalue: "By Number of value",
    viewmoretradeinfo: "view more trade info",
    SearchHSCode: "Search HS Code",
  },
  SupplyChain: {
    Illustratesthesubjectcompany:
      "This chart illustrates the subject company’s “buy from” and “sell to” relationships. The larger the volume, the thicker the tube.",
  },
  ShippingOrderDetails: {
    Date: "Date",
    MasterBillofLading: "Master Bill of Lading",
    Source: "Source",
    BillNo: "Bill No",
    ImporterBuyer: "Importer / Buyer",
    ExporterSeller: "Exporter / Seller",
    Name: "Name",
    Address: "Address",
    Country: "Country",
    Contact: "Contact",
    Email: "Email",
    CargoInfo: "Cargo Info",
    HSCode: "HS Code",
    Quantity: "Quantity",
    WeightUnit: "Weight Unit",
    ProductDescription: "Product Description",
    Amount: "Amount",
    QuantityUnit: "Quantity Unit",
    Weight: "Weight",
    HSDescription: "HS Description",
    Incoterms: "Incoterms",
    ShippingInfo: "Shipping Info",
    Vessel: "Vessel",
    Consignee: "Consignee",
    MeansofTransport: "Means of Transport",
    CountryofOrigin: "Country of Origin",
    Voyage: "Voyage",
    Notifier: "Notifier",
    CountryofDestnation: "Country of Destnation",
    AddressofOrigin: "Address of Origin",
    Shipper: "Shipper",
    AddressofDestnation: "Address of Destnation",
    Container: "Container",
    ContainerID: "Container ID",
    ContainerType: "Container Type",
    ContainerDescDode: "Container Desc Dode",
    ContainerSize: "Container Size",
    ImportExport: "Importer / Exporter",
  },
  FinancialHighlight: {
    Revenue: "Revenue", //收入
    Profit: "Profit", //利润
    Growth: "Growth", //增长
    Liquidity: "Liquidity", //现金流状况
    FinancialStructure: "Financial Structure", //融资结构
    CreditOpinion: "Credit Opinion", //信用评估
    RiskIndicator: "Risk Indicator ", //风险指标
    Solvencyindex: "Solvency index", //偿还指数
    Year: "Year", //年份
    Change: "Change", //变化
    NetProfit: "Net Profit",
    TotalAssets: "Total Assets",
    Equity: "Equity",
    GrossMargin: "Gross Margin",
    ProfitMargin: "Profit Margin",
    ReturnonEquity: "Return on Equity",
    CurrentRatio: "Current Ratio",
    DebtRatio: "Debt Ratio",
    FinancialHighlights: "Financial data from the related companies", //关联公司财务数据
    FinancialHighlightsTitle: "Financial Highlights from the Related Companies", //关联公司财务摘要
    CompanyName: "Company Name", //公司名称
    CompanyID: "Company ID", //公司ID
    Country: "Country", //国家/地区
    CompanyStatus: "Company Status", //公司状态
    Cancel: "Cancel", //取消
    Select: "Select",
    Relations: "Relations", //关系
    RatioAnalysis: "Ratio Analysis from the Related Companies", //关联公司比率分析
    Financialperformancedata:
      "Financial performance data is collected from various governmental sources and local credit reporting agencies. Additionally, market and industry research is used to calculate and model the data. For more detailed information about the actual operations and performance analysis, please contact our service team to request a company due diligence report.",
    Whenthesubjectsdata:
      "When the subject’s data is insufficient, or you’re interested in gaining more insights into your customer, this platform offers a comprehensive view of all entities related to the subject. This includes the subject’s company’s shareholders, related companies, and more.",
    Byprovidingyou:
      "By providing you with a broader perspective, this platform empowers you to make more informed evaluations and gain a deeper understanding of your subject.",
    PleaseSelectTheYeartoDisplay: "Please Select The Year to Display",
    SelectUptoThreeYears: "Select Up to Three Years",
  },
  RatioAnalysis: {
    ProfitabilityRatios: "Profitability Ratios",
    Year: "Year", //年份
    Change: "Change", //变化
    Returnonequity: "Return on equity",
    Returnonassets: "Return on assets",
    Profitmargin: "Profit margin",
    Grossmargin: "Gross margin",
    OperatingRatios: "Operating Ratios",
    Assetsturnover: "Assets turnover",
    Stockturnover: "Stock turnover",
    Salesperiod: "Sales period",
    Collectionperiod: "Collection period",
    Creditperiod: "Credit period",
    StructuralRatios: "Structural Ratios",
    Currentratio: "Current ratio",
    Quickratio: "Quick ratio",
    Shareholdersliquidityratio: "Shareholders liquidity ratio",
    Solvencyratio: "Solvency ratio",
    Debtratio: "Debt ratio",
    ProductivityRatios: "Productivity Ratios",
    Profitperemployee: "Profit per employee",
    Operatingrevenueperemployee: "Operating revenue per employee",
    Shareholdersfundsperemployee: "Shareholders funds per employee",
    Totalassetsperemployee: "Total assets per employee",
    GrowthRatios: "Growth Ratios",
    Salesgrowthrate: "Sales growth rate",
    Netprofitgrowthrate: "Net profit growth rate",
    Totalassetsgrowthrate: "Total assets growth rate",
    FinancialHighlights: "Financial data from the related companies", //关联公司财务数据
    RatioAnalysis: "Ratio Analysis from the Related Companies", //关联公司比率分析
    CompanyName: "Company Name",
    CompanyID: "Company ID",
    Country: "Country",
    CompanyStatus: "Company Status",
    Relations: "Relations",
  },
  IndustryNorms: {
    IndustryStatistics: "Industry Statistics",
    ofcompaniesintheIndustry: "No. of companies in the Industry",
    oflistedCompaniesintheIndustry: "No. of listed Companies in the Industry",
    oflargecompaniesintheIndustry: "No. of large companies in the Industry",
    ofSMEsintheIndustry: "No. of SMEs in the Industry",
    ofcompaniesinsample: "No. of companies in sample",
    ofcompaniesinloss: "No. of companies in loss",
    Observations: "Observations",
    AverageValue: "Average Value",
    MedianValue: "Median Value",
    MaximumValue10: "Maximum Value 10%",
    MinimumValue10: "Minimum Value 10%",
    SubjectCompany: "Subject Company",
    YearsinBusiness: "Years in Business",
    TotalAssets: "Total Assets",
    TotalEquity: "Total Equity",
    Revenue: "Revenue",
    NetEarning: "Net Earning",
    Returnonassets: "Return on assets",
    Performance: "Performance",
    ProfitabilityRatios: "Profitability Ratios",
    Returnonequity: "Return on equity",
    Returnonassets: "Return on assets",
    Grossmargin: "Gross margin",
    OperatingRatios: "Operating Ratios",
    Stockturnover: "Stock turnover",
    Accountsreceivableturnover: "Accounts receivable turnover",
    Assetsturnover: "Assets turnover",
    Totalassetturnover: "Total asset turnover",
    StructuralRatios: "Structural Ratios",
    Currentratio: "Current ratio",
    Quickratio: "Quick ratio",
    Shareholdersliquidityratio: "Shareholders liquidity ratio",
    GrowthRatios: "Growth Ratios",
    Salesgrowthrate: "Sales growth rate",
    Netprofitgrowthrate: "Net profit growth rate",
    Totalassetsgrowthrate: "Total assets growth rate",
  },
  Lawsutis: {
    Lawsutis: "Lawsutis",
    Date: "Date",
    CaseCategory: "Case Category",
    Title: "Title",
    CaseNo: "Case No.",
    CauseofAction: "Cause of Action",
  },
  News: {
    Date: "Date", //日期
    Title: "Title", //标题
    Source: "Source", //来源
    Impact: "Impact", //影响
    Searchcompanies: "Search more news on other companies", //国家/地区
    SearchforTitle: "Search for Title",
  },
  Sanctions: {
    Potentialcompliance: "Potential compliance risks is detected", //检测到潜在合规风险
    SeachbuttonNo: "Nothing detrimental is detected about this company", //未检测到任何与该公司相关的不良记录
    SeachbuttonYes:
      'To search for more sanction records, please clickon the"Search Sanctions" button.', //要搜索更多制裁记录，请点击“搜索制裁”按钮。
    SearchSanctions: "Search Sanctions", //搜索制裁
    ViewDetails: "View Details", //查看详情
    Sanctions: "Sanctions", //制裁
    Potentialcompliancerisks: "Potential compliance risks", //潜在合规风险
    IDInfo: "ID Info", //ID 信息
    IDType: "ID Type", //ID 类型
    IDDescription: "ID Description", //ID 描述
    SanctionList: "Sanction List", //制裁名单
    SanctionListInvolved: "Sanction List Involved", //涉及的制裁名单
    StartDate: "Start Date", //生效日期
    EndDate: "End Date", //结束日期
    SourceList: "Source List", //来源名单
    SourceName: "Source Name", //来源名称
    ProfileNotes: "Profile Notes", //主体资料
    Link: "Link", //链接
    Name: "Name",
    AssociationList: "Association List",
    AssociationID: "Association ID",
    AssociationType: "Association Type",
  },
  CreditOpinion: {
    CreditAssessment: "Credit Assessment",
    CreditAssessmentfromtheRelatedCompanies:
      "Credit Assessment from the Related Companies",
    Year: "Year",
    CreditRating: "Credit Rating",
    LocalCreditScore: "Local Credit Score",
    ProbabilityofDefault: "Probability of Default",
    SolvencyIndex: "Solvency Index",
    CreditLine: "Credit Line",
    RiskIndicator: "Risk Indicator",
    RelatedCreditAssessment: "Related Credit Assessment",
    CompanyName: "Company Name",
    CompanyID: "Company ID",
    Country: "Country",
    CompanyStatus: "Company Status",
    Relations: "Relations",
    Cancel: "Cancel",
    Select: "Select",
    LocalCreditScore: "Local Credit Score",
    SolvencyIndex: "Solvency Index",
    ProbabilityofDefault: "Probability of Default",
    RiskIndicator: "Risk Indicator",
    CreditAssessmentMessage1:
      "When the subject’s data is insufficient, or you’re interested in gaining more insights into your customer, this platform offers a comprehensive view of all entities related to the subject. This includes the subject’s company’s shareholders, related companies, and more.",
    CreditAssessmentMessage2:
      "By providing you with a broader perspective, this platform empowers you to make more informed evaluations and gain a deeper understanding of your subject.",
    LocalCreditRating: "Local Credit Rating",
    LocalCreditRatingDetail:
      "Driven by the power of big data, 3ARating is a quantitative rating system for private companies. It is a collaborative effort between 3ACredit and Creditreform Rating. The rating model is built based on a comprehensive evaluation of various key factors, including non-financial factors, financial factors, negative records, and industry-specific considerations. The rating model exhibits an impressive Gini coefficient, indicating its robustness and reliability. 3ARating spans a range of ratings, from the highest rating, 3A1, to the lowest rating class, 3A19.",
    CreditScore: "Credit Score",
    CreditScoreDetail:
      "Credit scores are calculated on a scale from 1 to 100, based on the credit rating obtained from local authorities. A higher score indicates better creditworthiness.",
    PossibilityofDefault: "Possibility of Default (PD)",
    PossibilityofDefaultDetail:
      "The Possibility of Default (PD) is a useful tool for risk assessment, focusing on short-term liquidity evaluation.",
    SolvencyIndexSI: "Solvency Index (SI)",
    SolvencyIndexSIDetail:
      "The Solvency Index (SI) is a highly effective and reliable early warning indicator that allows for a rapid assessment of the solvency of business partners. A higher SI value indicates a higher risk of default by a client. The SI ranges from 100, which is considered an excellent rating, to 600, where highly negative characteristics are present.",
    ExternalRating: "External Rating",
    DefaultProbability: "Default Probability(Pd1Year)",
    Rating: "3ARating (>=,<=)",
    PleaseSelectTheYeartoDisplay: "Please Select The Year to Display",
    SelectUptoThreeYears: "Select Up to Three Years",
  },
  IndustryStatistics: {
    SubjectCompany: "Subject Company",
    Country: "Country",
    Compare: "Compare",
    Industry: "Industry",
    CompanyType: "Company Type",
    CompanySize: "Company Size",
    CompanyStatus: "Company Status",
    YearsinBusiness: "Years in Business",
    CompanyRating: "Company Rating",
    Liquidity: "Liquidity",
    NoofcoinIndustry: "No. of co. in Industry",
    IndustryRating: "Industry Rating",
    Profitability: "Profitability",
    Growth: "Growth",
    FinancialStructurt: "Financial Structurt",
    Repaying: "Repaying",
    SearchCountry: "Search Country",
  },
  RatingAnalysis: {
    IndustyAnalysis: "Industy Analysis",
    GeographicAnalysis: "Geographic Analysis",
    CompanyTypeAnalysis: "Company Type Analysis",
    BiusinessScaleAnalysis: "Biusiness Scale Analysis",
    HistoryAnalysis: "History Analysis",
    NormalDistribution: "Normal Distribution",
    SubjectCompany: "Subject Company",
    Probabilityofthesubjectratinginitsindustry:
      "Probability of the subject rating in its industry",
    Maximum: "Maximum 10%",
    Mean: "Mean",
    Average: "Average",
    Minimum: "Minimum 10%",
    RatingDistribution: "Rating Distribution",
    Revenue: "Revenue",
    Earning: "Earning",
    TotalAssets: "Total Assets",
    Subjectratinginitsindustrybyfinancialindicators:
      "Subject rating in its industry by financial indicators",
    Best: "Best",
    Worst: "Worst",
    Rankingofsubject: "Ranking of subject's rating in the industry",
    Industy: "Industy",
    Percentilerank:
      "Percentile rank: % of companies that scored at or below subjects rating",
    Historicaldevelopmentofsubject:
      "Historical development of subject's rating in its industry",
    IndustryAverage: "Industry Average",
    SubjectRatingChanges: "Subject Rating Changes",
    CreditScore: "Credit Score",
    NOofCompanies: "NO. of Companies",
    ofCompanies: "% of Companies",
    CreditRating: "Credit Rating",
    CompanySize: "Company Size",
    YearsinBusiness: "Years in Business",
    SubjectsIndustryConcentrationAnalysis:
      "Subject's Industry Concentration Analysis",
    GeographicdistributionofSubjectsratingintsindustry:
      "Geographic distribution of Subject's rating in its industry",
    GeographicdistributioninSubjectindustry:
      "Geographic distribution in Subject's industry：",
    RatingDistributioninSubjectsLocation:
      "Rating Distribution in Subject's Location",
    Ratinganalysisofcompanies:
      "Rating analysis of companies in the same industry with different years in business",
    Subjectsratinghistory:
      "Subject's rating history comparing with its peers with the same history",
    Ratingrankingofcompanieswithsamehistory:
      "Rating ranking of companies with same history",
    Ratingstatistics:
      "Rating statistics of companies with the same years in business",
    Subjectratingcomparing:
      "Subject rating comparing with its peer companies with the",
    Subjectratinginitsgroup: "Subject rating in its group:",
    Analysisbasedonnature:
      "Analysis based on nature of companies in subject's industry",
    Subjectratingpositioninitscompanytype:
      "Subject rating position in its company type:",
    Ratingstatisticsofcompanies:
      "Rating statistics of companies in the same industry",
    Ratinganalysisofcompanies:
      "Rating analysis of companies of different sizes in the same industry",
    Probabilityofsubjectrating:
      "Probability of subject rating in its industry within its size",
    Subjectratingcomparingwithindustry:
      "Subject rating comparing with its peers in its industry:",
    RatingRankingofthecompanies:
      "Rating Ranking of the companies in the same size in the same industry",
    Ratingstatisticsofcompanies:
      "Rating statistics of companies in the same size and same industry",
    Rank: "Rank",
    Rating: "Rating",
  },
  CompetitiveAnalysis: {
    MarketPosition: "Market Position",
    Revenus: "Revenus",
    NetEarnings: "Net Earnings",
    NetAssets: "Net Assets",
    TotalAssets: "Total Assets",
    Employees: "Employees",
    Mean: "Mean",
    Average: "Average",
    Maximum: "Maximum (10%)",
    Worst: "Worst (10%)",
    Subjectcompany: "Subject company",
    PerformanceComparison: "Performance Comparison",
    ProfitabilityRatios: "Profitability Ratios",
    Grossmargin: "Gross margin",
    Returnonassets: "Return on assets",
    Returnonequity: "Return on equity",
    OperatingRatios: "Operating Ratios",
    Stockturnover: "Stock turnover",
    Assetsturnover: "Assets turnover",
    Collectionperiod: "Collection period",
    GrowthRatios: "Growth Ratios",
    Totalassetsgrowthrate: "Total assets growth rate",
    Salesgrowthrate: "Sales growth rate",
    Netprofitgrowthrate: "Net profit growth rate",
    StructuralRatios: "Structural Ratios",
    Debtratio: "Debt ratio",
    Quickratio: "Quick ratio",
    Currentratio: "Current ratio",
  },
  AccountCenterMenu: {
    SearchinSettings: "Search in Settings", //在“设置”中搜索
    Account: "Account", //账户
    MyAccount: "My Account ", //我的账户
    ContactInfo: "Contact Info", //联系信息
    AccountSecurity: "Account Security", //账户安全
    OrganizationalManagement: "Organizational Management", //组织管理
    UserGroup: "User Group", //用户组
    User: "User", //用户
    Role: "Role", //角色
    MyDatabase: "My Database", //我的数据库
    MyUsage: "My Usage", //我的使用情况
    CompaniesViewed: "Companies Viewed", //查看过的公司
    ReportsDownloaded: "Reports Downloaded", //下载的报告
    ReportUpdatesOrdered: "Report Updates Ordered", //订购的报告更新
    BillingandPayment: "Billing and Payment", //账单和付款
    BillRecords: "Bill Records", //账单记录
    PaymentRecords: "Payment Records", //付款记录
    CreditDeductions: "Credit Deductions", //信用扣款
    InvoicesDownloaded: "Invoices Downloaded", //下载的发票
    UserSettings: "User Settings", //用户设置
    Messages: "Messages", //消息
    Notifications: "Notifications", //通知
    HelpCenter: "Help Center", //帮助中心
    FAQ: "FAQ", //常见问题
    Privacy: "Privacy", //隐私
    Terms: "Terms", //条款
    ReportIssues: "Report Issues", //报告问题
    UserGuide: "User Guide", //用户指南
    AboutCSI: "About CSI", //关于CSI
  },
  MyAccount: {
    Logintime: "Login time", //登录时间
    SignOut: "Sign Out", //退出
    DeleteAccount: "Delete Account", //删除账户
    AccountID: "Account ID", //账户ID
    Enteranewaddress: "Enter a new email address", //输入新的电邮
    EnterVerificationCode: "Enter Verification Code", //输入验证码
    SendverificationCode: "Send verification Code", //发送验证码
    Password: "Password", //密码
    Originalpassword: "Original password", //原始密码
    Newpassword: "New password", //新密码
    Confirmnewpassword: "Confirm new password", //确认新密码
    AccountOwnership: "Account Ownership", //账户所有权
    IndividualAccount: "Individual Account", //个人账户
    GroupAccount: "Group Account", //集团账户
    Organizationname: "Organization name", //机构名称
    CountryRegion: "Country/Region", //国家/地区
    Address: "Address", //地址
    City: "City", //城市
    ZipCode: "Zip Code", //邮政编码
    FirstName: "First Name", //名字
    LastName: "Last Name", //姓氏
    PhoneNumber: "Phone Number", //电话号码
    Email: "Email", //更改
    Change: "Change", //更改
    Save: "Save", //保存
    Cancel: "Cancel", //取消
    LastLogin: "Last Login", //上次登录
    RecentLogin: "Recent Login", //登录尝试次数
    AverageLoginTime: "Average Login Time", //平均登录时间
    TotalLoginAttempts: "Total Login Attempts", //登录尝试次数
    Registrationtime: "Registration time",
    Role: "Role",
    Administrator: "Administrator",
    Enterpriseusers: "Enterprise users",
    EditImage: "Edit Image",
    DeleteImage: "Delete Image",
  },
  ContactInfo: {
    ContactInfo: "Contact Info",
    FirstName: "First Name",
    LastName: "Last Name",
    PhoneNumber: "Phone Number",
    Email: "Email",
    CountryRegion: "Country/Region",
    AddressLine: "Address Line",
    City: "City",
    ZipCode: "Zip Code",
    Alternativecontactperson: "Alternative contact person",
    Setascontactperson: "Set as contact person",
    Edit: "Edit",
  },
  AccountSecurity: {
    Setupmysecurityquestions: "Set up my security questions",
    Pleasechooseaquestion: "Please choose a question",
    Pleaseentertheanswertothequestion:
      "Please enter the answer to the question",
    SessionTimeoutAutomaticLogoutSettings:
      "Session Timeout: Automatic Logout Settings",
    Thesystemwillautomatically:
      "The system will automatically log you out after a period of inactivity. The default timeout is set to 5 minutes, but you can adjust this duration as needed.",
  },
  MyDatabase: {
    TotalNumberofCompaniesSearched: "Total Number of Companies Searched",
    TotalNumberofCompaniesCollected: "Total Number of Companies Collected",
    TotalNumberofUpdateReportsOrdered: "Total Number of Update Reports Ordered",
    Date: "Date",
    UserName: "User Name",
    CompanyName: "Company Name",
    Status: "Status",
    UsageType: "Usage Type",
    Entercompanyname: "Enter company name",
    Download: "Download",
  },
  OrganizationalManagement: {
    GroupName: "Group Name",
    ParentGroupName: "Parent Group Name",
    Organization: "Organization",
    GroupID: "Group ID",
    GroupStatus: "Group Status",
    Operation: "Operation",
    NewlyBuilt: "Newly Built",
    UserAccount: "User Account",
    Role: "Role",
    AccountStatus: "Account Status",
    RoleName: "Role Name",
    Position: "Position",
    RoleStatus: "Role Status",
    Valid: "Valid",
    Invalid: "Invalid",
    PermissionSettings: "Permission Settings",
    ShowMore: "Show More",
    Search: "Search",
    Cancel: "Cancel",
    Confirm: "Confirm",
    NewGroup: "New Group",
    EnterGroupName: "Enter Group Name",
    NumberofGroups: "Number of Groups",
    Groups: "Groups",
    Roles: "Roles",
    NewRoles: "New Roles",
    EnterNewRole: "Enter New Role",
    Users: "Users",
    EnterUserName: "Enter User Name",
  },
  BillingandPayment: {
    TotalNumberofOrders: "Total Number of Orders",
    TotalPaymentAmount: "Total Payment Amount",
    TotalDeductionCredits: "Total Deduction Credits",
    Date: "Date",
    UserAccount: "User Account",
    CompanyName: "Company Name",
    OrderNo: "Order No.",
    OrderType: "Order Type",
    OrderStatus: "Order Status",
    Download: "Download",
    PaymentAmount: "Payment Amount",
    Contactus: "Contact us",
    DownloadInvoice: "Download Invoice",
    CreditsDeducted: "Credits Deducted",
    ReportOrderStatus: "Report Order Status",
    CompanyID: "Company ID",
    CountryRegion: "Country/Region",
    AddressLine: "Address Line",
    City: "City",
    ZipCode: "Zip Code",
    FirstName: "First Name",
    LastName: "Last Name",
    PhoneNumber: "Phone Number",
    Email: "Email",
    BankAccountHolderName: "Bank Account Holder Name",
    BeneficiaryBankName: "Beneficiary Bank Name",
    SWIFTCODE: "SWIFT CODE",
    AccountNumber: "Account Number",
    BeneficiaryBankAddress: "Beneficiary Bank Address",
    ABA: "ABA(Routing Number)",
    IBANnumber: "IBAN number",
    StartingMonth: "Starting Month",
    EndMonth: "End Month",
  },
  UserSettings: {
    LanguageandLocation: "Language and Location",
    Language: "Language",
    Selectyourpreferedlanguage: "Select your prefered language",
    Location: "Location",
    Selectyourlocation: "Select your location",
    NotificationSetting: "Notification Setting",
    EmailNotification: "Email Notification",
    ServiceUpdates: "Service Updates",
    CompanyNews: "Company News",
  },
  AddCredit: {
    Customizeyourplan: "Customize your plan however you need",
    Silver: "Silver",
    Gold: "Gold",
    Enterpris: "Enterpris",
    Credit: "Credit",
    Remaining: "Remaining",
    Points: "points",
    Usermonth: "user/ month",
    Useryear: "user/ year",
    PaidMonthlyRenews: "Paid monthly, no need for auto renews",
    PaidAnnuallyRenews: "Paid annually, no need for auto renews",
    ForFullSupport: "for full support to your needs",
    Each: "each",
    CreditsCharged:
      "Credits charged to your account will never expire as long as your account remains active.",
    PaidMonthly: "Paid monthly",
    PaidAnnually: "Paid annually",
    BuyNow: "Buy now",
    ContactNow: "Contact now",
    SearchCompanies:
      "Search companies and get an instant access to company data that includes:",
    EverythinginSilverPackage: "Everything in Silver package, plus:",
    CreditsCanbeUsed:
      "Credits can be used for more data services including the followings:",
    UnlimitedAdvancedSearch: "Unlimited advanced search",
    ViewCompanyProfile: "View company profile",
    CompanyOwnershipStructure: "Company ownership structure",
    CompanyFamilyTree: "Company family tree",
    Companymanagement: "Company management",
    CompanyContactsinfo: "Company contacts info",
    BusinessActivities: "Business activities",
    IndustryBasics: "Industry basics",
    ImportExportRecords: "Import & export records",
    CompanyPublications: "Company publications",
    CompanyNews: "Company news",
    DownloadOnlineReport: "Download online report",
    ManagementDetails: "Management details",
    ShareholderPenetration: "Shareholder penetration (UBO)",
    Financialinfo: "Financial info",
    FinancialAnalysis: "Financial analysis",
    CreditAssessment: "Credit assessment",
    IndustryAnalysis: "Industry analysis",
    MarketAnalysis: "Market analysis",
    SupplyChaininfo: "Supply Chain info",
    CheckSanctions: "Check sanctions",
    CompanyComparison: "Company comparison",
    DataExport: "Data export",
    MonitoringService: "Monitoring service",
    DiscountForFreshUpdateReports: "Discount for fresh update reports",
    SearchCompany: "Search Company",
    SearchLeads: "Search Leads",
    SearchTrade: "Search Trade",
    SearchPeople: "Search People",
    SearchCountry: "Search Country",
    SearchNews: "Search News",
    SearchSanction: "Search Sanction",
    DataServices: "Data Services",
    APIPlans: "API Plans",
    VolumeDiscounts: "Volume Discounts",
    GroupAccountsWithMultipleUsers: "Group Accounts with multiple users",
    CustomizedPlans: "Customized Plans",
    FreshInvestigatedCreditReportsWorldwide:
      "Fresh investigated credit reports worldwide",
    BusinessMonitoringServices: "Business monitoring services",
    BusinessProcessVerificationServices:
      "Business process verification services",
    VendorComplianceReports: "Vendor compliance reports",
    MarketResearch: "Market research",
    More: "More…",
    Contactus: "Contact us",
    PaymentMethod: "Payment Method",
    CreditCardNumber: "Credit Card Number",
    EnterCardNumber: "Enter Card Number",
    ExpirationDate: "Expiration Date",
    Fullnameoncard: "Full name on card",
    EnterFullname: "Enter Full name",
    EnterProvinceState: "Enter Province / State",
    CVCCode: "CVC Code",
    EnterCVCCode: "Enter CVC Code",
    IncorrectCreditCardNumberformat: "Incorrect Credit Card Number format ",
    IncorrectExpMonthformat: "Incorrect Exp.Month format",
    IncorrectExpYearformat: "Incorrect Exp.Year format",
    IncorrectFullNameformat: "Incorrect Full Name format",
    IncorrectCountryformat: "Incorrect Country format",
    IncorrectProvinceStateformat: "Incorrect Province / State format",
    IncorrectCVCCodeformat: "Incorrect CVC Code format",
    TotalPurchase: "Total Purchase",
    Agree1: "By clicking “Submit”, you agree to the ",
    Agree2: "CSI Services Agreement and Privacy .",
    Submit: "Submit",
    Month: "Month",
    Year: "Year",
    Country: "Country",
    ProvinceState: "Province/State",
    Cancel: "Cancel",
  },
  ReportIssues: {
    Whattypeoferrorsyouarereporting: "What type of errors you are reporting?",
    Tellusmoreaboutyourproblems: "Tell us more about your problems.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:
      "Would you like to provide a screenshot or a file regarding your problem?",
    Fillinyourcontactinformation: "Fill in your contact information",
    FirstName: "First Name",
    LastName: "Last Name",
    PhoneNumber: "Phone Number",
    Email: "Email",
    Edit: "Edit",
  },

  //Risk Scan
  RiskScan: {
    RiskScan: "Risk Scan",
    RiskScanInfo: " is your all-in-one platform for comprehensive corporate risk intelligence. We provide detailed analysis across every major risk category to safeguard your business decisions.",
    LegalRisk: "Legal Risk",
    LegalRiskInfo: "Verify company’s legitimacy.",
    OrganizationalRisk: "Organizational Risk",
    OrganizationalRiskInfo: "Management stability, corporate structure complexity, and ownership transparency.",
    OperationalRisk: "Operational Risk",
    OperationalRiskInfo: "Supply chain vulnerabilities, operational status, and geopolitical exposure.",
    FinancialRisk: "Financial Risk",
    FinancialPerformanceRiskInfo: "Profitability trends, liquidity issues, and balance sheet health.",
    CreditRisk: "Credit Risk",
    CreditRiskInfo: "Creditworthiness, payment history, and probability of default.",
    ComplianceRisk: "Compliance Risk",
    ComplianceRiskInfo: "Adherence to sanctions, AML regulations, and industry-specific laws",
    SustainabilityRisk: "Sustainability Risk",
    SustainabilityRiskInfo: "ESG (Environmental, Social, Governance) factors and reputational impacts.",
    IndustryRisk: "Industry Risk",
    IndustryRiskInfo: "Assesses the stability and outlook of a company's entire sector.",
    LetBegin: "Let's Begin",
    AddcompaniesfromSearchResult: "Add companies from Search Result",
    AddcompaniesfromMyDatabase: "Add companies from My Database",
    Addcompaniesbyuploadmyownlist: "Add companies by upload my own list",
    Cancel: "Cancel",
    Confirm: "Confirm",
    UploadFiles: "Upload Files",
    PleaseuploadyourfileinCVSformat: "Please upload your file in xlsx format.",
    Downloadxlsxtemplate: "Download xlsx template",
    Xcompanieswereuploadedsucessfuly: "companies were uploaded sucessfuly.",
    Xcompanieswereidentifiedsucessfuly: "companies were identified sucessfuly.",
    Xcompanieswerenotmatched: "companies were not matched.",
    Uploadingfilefailed: "Uploading file failed. Please use the template and try again.",
    ALL: "ALL",
    SearchLeads: "Search Leads",
    LastUpdate: "Last Update",
    CompanyID: "Company ID",
    CompanyType: "Company Type",
    RegistrationDate: "Registration Date",
    RegistrationStatus: "Registration Status",
    Listed: "Listed",
    LegalStatus: "Legal Status",
    NoofShareholders: "No. of Shareholders",
    ShareholdingLayers: "Shareholding Layers",
    NoofCorporateShareholders: "No. of Corporate Shareholders",
    NoofNatualPersonShareholders: "No. of Natual Person Shareholders",
    RelatedCompanies: "Related Companies",
    OrganizationalStatus: "Organizational Status",
    OperatingAddress: "Operating Address",
    IndustryCode: "Industry Code",
    BusinessActivities: "Business Activities",
    NoofEmployees: "No. of Employees",
    Management: "Management",
    CurrentOperations: "Current Operations",
    Revenue: "Revenue",
    Assests: "Assests",
    ProfitLoss: "Profit/Loss",
    Liquidity: "Liquidity",
    Growth: "Growth",
    Performance: "Performance",
    CreditRating: "Credit Rating",
    CreditScore: "Credit Score",
    PausibilityofDefault: "Pausibility of Default (PD)",
    SolvencyIndex: "Solvency Index",
    DebtCollection: "Debt Collection",
    CreditOpinion: "Credit Opinion",
    CompanySanction: "Company Sanction",
    ProductSanction: "Product Sanction",
    ExportControl: "Export Control",
    AntiCorruptionAntiBribery: "Anti-Corruption & Anti-Bribery",
    Litigations: "Litigations",
    NegativeNews: "Negative News",
    ESGScore: "ESG Score",
    YearsinBusiness: "Years in Business",
    Competitiveness: "Competitiveness",
    WorkingCapital: "Working Capital",
    FinancialStructure: "Financial Structure",
    Industrystatus: "Industry status",
    IndustryOutlook: "Industry Outlook",
    NoofCompanies: "No. of Companies",
    IndustryRanking: "Industry Ranking",
    IndustryConcentration: "Industry Concentration",
    IndustryCompetitiveness: "Industry Competitiveness",
    IndustryDevelopment: "Industry Development",
    CompanyName: "Company Name",
    Legal: "Legal",
    Organizational: "Organizational",
    Operational: "Operational",
    Financial: "Financial",
    Credit: "Credit",
    Compliance: "Compliance",
    Sustainability: "Sustainability",
    Industry: "Industry",
    Download: "Download",
    StartDate: "Start Date",
    EndDate: "End Date",
    Entercompanyname: "Enter Company Name",
    Uploadyourlistofcompanies: "Upload your list of companies, and Risk Scan will provide you with instant data updates for each entity. With comprehensive risk assessments across seven risk categories, Risk Scan transforms your risk management from reactive to a proactive strategic advantage.",
    Choose: "Choose",
    Upload: "Upload",
    Uploading: "Uploading",
    Uploadwithamaximumfilesizeof1M: "（Upload up to 100 pieces of data at a time, with a maximum file size of 1M）",
    Tryagain: "Try again",
    Theuploadedonlyxlsx: "The uploaded file can only be in xls/xlsx format",
    RiskScanning: "Risk Scanning",
    Youhaveselectedatotalof: "You have selected a total of",
    Tostartriskscanning: "companies, click “confirm” to start risk scanning",
    Datascanningisinprogress: "Data scanning is in progress ...",
    ClearAll: 'Clear All',
    SelectUpdateDate: "Select Last Update",
    UpdateStatus: "Update Status",
    Updated: "Updated",
    Notupdated: "Not updated",
    Updating: "Updating",
    SelectRiskValue: "Select Risk Value",
    ReSelectData: "Re Select Data",
    HistoricalData: "Historical Data",
    DiagnosticReport: "Diagnostic Report",
    Good: "Good",
    General: "General",
    Differ: "Differ",
    NotEvaluated: "Not Evaluated",
    ScanTime: "Scan Time",
    Rescan: "Rescan",
  },
  //Data Management
  DataManagement: {
    DataManagement: "Data Management",
    AllCompanies: "All Companies",
    CompaniesViewed: "Companies Viewed",
    CompaniesCollected: "Companies Collected",
    CompaniesUploaded: "Companies Uploaded",
    MyPortfolio: "My Portfolio",
    Date: "Date",
    CompanyName: "Company Name",
    Country: "Country",
    CompanyType: "Company Type",
    CompanyStatus: "Company Status",
    DQI: "DQI",
    Download: "Download",
    Addcompanies: "Add companies",
    Filter: "Filter",
    Selectcountry: "Select Country",
    Selectindustry: "Select Industry",
    Selectcompanytype: "Select company type",
    Selectcompanysize: "Select company size",
    Selectcompanystatus: "Select company status",
    Selectlistedcompanies: "Select listed companies",
    Selectcompanyyearsinbusiness: "Select company years in business",
    Industry: "Industry",
    CompanySize: "Company Size",
    Listed: "Listed",
    CompanyAge: "Company Age",
    SelectYear: "Select Year",
    SelectQuarter: "Select Quarter",
    SelectMonth: "Select Month",
    Reset: "Reset",
    Search: "Search",
    MyDatabase: "My Database",
    CountriesLocated: "Countries Located",
    YearsinBusiness: "Years in Business",
    CompanyDQI: "Company DQI",
    RiskScan: "Risk Scan",
    CreditAssessment: "Credit Assessment",
    Uptodate: "Up to date",
    Average: "Average",
    Insufficient: "Insufficient",
    Good: "Good",
    Caution: "Caution",
    Unknown: "Unknown",
    CompanyTag: "Company Tag",
    Remove: "Remove",
    Uploaded: "Uploaded",
    Identified: "Identified",
    Notmatched: "Not matched",
    Uploadfiles: "Upload files",
    Identifythecompanywithmanualcheck: "Identify the company with manual check",
    Identifyacompanymanually: "Identify a company manually",
    Pleaseprovideanyrelevantinformation: "Please provide any relevant information that could enhance the search results. Our data analyst will match you with the most suitable company.",
    RegistrationID: "Registration ID",
    StateProvince: "State/Province",
    Address: "Address",
    Otherinformation: "Other information",
    Submit: "Submit",
    Cancel: "Cancel",
    Confirm: "Confirm",
    PortolioName: "Portolio Name",
    User: "User",
    Task: "Task",
    NoofCompanies: "No. of Companies",
    Entercompanyname: "Enter company name",
    SaveYourPortfolio: "Save Your Portfolio",
    PortfolioName: "Portfolio Name",
    Notes: "Notes",

    //未对应
    Rescan: "Rescan",
    Match: "Match",
    Delete: "Delete",
    Edit: "Edit",
    AllData: "All Data",
    CountriesLocated: "Countries Located",
    EnterRegistrationID: "Enter Registration ID",
    EnterAddress: "Enter Address",
    EnterInformation: "Enter Information",
    EnterPortfolioName: "Enter Portfolio Name",
    EnterUserName: "Enter User",
    SelectTaskName: "Select Task",
    EnterNotes: "Enter Notes",
    OnlineMatching: "Online Matching",
    StartingMonth: "Starting Month",
    EndMonth: "End Month",
  },

  Relationship: {
    SearchRelationship: "Search Relationship",
    SearchRelationshipInfo:
      " is our premier data service designed to illuminate the complete corporate ecosystem of any business. The platform delivers a comprehensive 360-degree view of your subject company, revealing:",
    UltimateOwnershipControl: "Ultimate Ownership & Control",
    UltimateOwnershipControlInfo:
      "Unmask the chain of ownership by tracing through complex layers to identify UBOs and all shareholders.",
    InvestmentParticipation: "Investment & Participation",
    InvestmentParticipationInfo:
      "Discover every company the subject has invested in, partnered with, or participated in, uncovering strategic directions and hidden alliances.",
    SupplyChainNetwork: "Supply Chain Network",
    SupplyChainNetworkInfo:
      "Map the spectrum of commercial relationships, identifying all possible vendors and clients to understand the full flow of commerce.",
    Ourplatformempowers:
      "Our platform empowers your critical decisions by helping you discover opportunities, streamline compliance, and mitigate risk. With Search Relationship, transparency is just a search away.",
    LetsBegin: "Let's Begin",
    Company: "Company",
    Product: "Product",
    Entercompanyname: "Enter company name",
    Enterproductkeywords: "Enter product keywords",
    UltimateOwnershipGlobalCoverage:
      "Ultimate Ownership & Control / Investment Footprint / Supply Chain Network / Streamline Compliance / Mitigate Risks / Global Coverage",
    CompanyName: "Company Name",
    Country: "Country",
    Industry: "Industry",
    CompanyType: "Company Type",
    CompanySize: "Company Size",
    CompanyStatus: "Company Status",
    ListingInfo: "Listing Info",
    YearsinBusiness: "Years in Business",
    HSCode: "Hs Code",
    HsCodeProduct: "Hs Code / Product",
    ImportExport: "Import & Export",
    IncDate: "Inc. Date",
    CompanySnapshot:"Company Snapshot",
    Address:"Address",
    CountyCity:"County/City",
    ProvinceState:"Province/State",
    CountryRegion:"Country/Region",
    ZipCode:"Zip Code",
    RegName:"Reg. Name",
    Website:"Website",
    Email:"Email",
    Tel:"Tel",
    LastUpdate:"Last Update",
    DataSource:"Data Source",
    CompanyProfile:"Company Profile",
    CoNativeName:"Co. Native Name",
    CompanyID:"Company ID",
    VATNumber:"VAT Number",
    StockNumber :"Stock Number",
    Listed:"Listed",
    RegistrationDate:"Registration Date",
    LegalForm:"Legal Form",
    LegalStatus:"Legal Status",
    Jurisdiction:"Jurisdiction",
    RegisteredAddress:"Registered Address",
    OperatingAddress:"Operating Address",
    Ownership:"Ownership",
    Investments:"Investments",
    PossibleVendors:"Possible Vendors",
    PossibleClients:"Possible Clients",
    UItimateBeneficiaryOwner:"UItimate Beneficiary Owner",
    ControllingShareholder:"Controlling Shareholder",
    Participations:"Participations",
    InvolvingIndividuals:"Involving Individuals",
    InvolvingEnterprises:"Involving Enterprises",
    ShareholdingLayers:"Shareholding Layers",
    RelatedCompany:"Related Company",
    CompanyShareholder:"Company Shareholder",
    NGOShareholder:"NGO Shareholder",
    NaturalPersonShareholder:"Natural Person Shareholder",
    SubjectsInvestments:"Subject's Investments",
    Name:"Name",
    Location:"Location",
    Type:"Type",
    Shares:"Shares (%)",
    Relations:"Relations",
    ShareholdingLayer:"Shareholding Layer",
    PartiesInvolved:"Parties Involved",
    RelatedCompanies:"Related Companies",
    CompanyShareholders:"Company Shareholders",
    NGOShareholders:"NGO Shareholders",
    NaturalPersonShareholders:"Natural Person Shareholders",
    ShareholderLevel:"Shareholder Level",
    Numberofshareholderenterprises:"Number of shareholder enterprises",
    Thelargestholdingcompany:"The largest holding company",
    CurrentLevel:"Current Level",
    SharesonSubjectCo:"Shares on Subject Co.",

    //未对应
    ClearAll: "Clear All",
    UBORuler:"UBO Ruler",
    EnterCurrentLevel:"Enter Current Level",
  },
  ...enLocale,
};

export default en;
